import { Box, Skeleton } from '@mui/material';

export default function MessageSkeleton() {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
            }}>
            <Box sx={{ paddingY: 2.5, paddingX: 3 }}>
                <Box sx={{ paddingBottom: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Skeleton variant="circular" width={24} height={24} />
                    <Skeleton variant="text" width="35%" height={20} />
                </Box>
                <Box sx={{ pl: 4 }}>
                    <Skeleton variant="text" width="75%" height={20} />
                </Box>
            </Box>
        </Box>
    );
}
